import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from './translations/en.json';
import polishMessages from './translations/pl.json';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, isLanguageSupported } from './languages';

const messages = {
    en: englishMessages,
    pl: polishMessages,
};

const readLocaleFromStorage = () => {
    try {
        const saved = localStorage.getItem('locale');
        if (saved && isLanguageSupported(saved)) {
            return saved;
        }
    } catch (error) {
        console.warn('Could not read locale from localStorage', error);
    }

    try {
        if (typeof globalThis !== 'undefined' && globalThis.navigator) {
            const navigatorLang = globalThis.navigator.language || globalThis.navigator.languages?.[0];
            if (navigatorLang) {
                const baseLang = navigatorLang.split('-')[0].toLowerCase();
                if (isLanguageSupported(baseLang)) {
                    return baseLang;
                }
            }
            console.warn('Brak wspieranego języka przeglądarki. Używany język domyślny:', DEFAULT_LANGUAGE);
        }
    } catch (error) {
        console.warn('Could not detect locale from browser', error);
    }

    return DEFAULT_LANGUAGE;
};

export const getCurrentLanguage = () => readLocaleFromStorage();

export const supportedLanguageCodes = SUPPORTED_LANGUAGES.map(language => language.code);

const polyglot = polyglotI18nProvider(locale => {
    if (!isLanguageSupported(locale)) {
        console.warn(`Language ${locale} is not supported. Falling back to ${DEFAULT_LANGUAGE}.`);
        return messages[DEFAULT_LANGUAGE];
    }
    return messages[locale] || messages[DEFAULT_LANGUAGE];
}, getCurrentLanguage());

export const i18nProvider = {
    ...polyglot,
    changeLocale: nextLocale => {
        if (!isLanguageSupported(nextLocale)) {
            console.warn(`Language ${nextLocale} is not supported. Ignoring.`);
            return Promise.resolve(getCurrentLanguage());
        }
        try {
            localStorage.setItem('locale', nextLocale);
        } catch (error) {
            console.warn('Could not persist locale to localStorage', error);
        }
        return polyglot.changeLocale(nextLocale);
    },
};
